import FusionChartsTypeMapping from '../constants/fusion_charts_types_mapping';

export const parseDataSourceFromXMLPath = (inputChartName, xmlPath) => {
	if (!xmlPath) return;
	
	return xmlPath.replace(/link=\\"JavaScript:(.+?)\\"/g, parseDataSourceLinkAttribute.bind(this, inputChartName));
};

export const parseFusionChartsTypeFromChartType = (chartType) => {
	return FusionChartsTypeMapping[chartType];
};

const parseDataSourceLinkAttribute = (inputChartName, attribute, linkJavascript) => {
	const chartItemClickFunctionRef = "Lecom.actions.ChartActions.chartItemClick";
	return `link="JavaScript:${chartItemClickFunctionRef}(&quot;${inputChartName}&quot;, &quot;${linkJavascript}&quot;)"`;
};

export const ChartDataHelpers = {
	parseDataSourceFromXMLPath,
	parseFusionChartsTypeFromChartType
};

export default ChartDataHelpers;
